// extracted by mini-css-extract-plugin
module.exports = {"componentsMapCarousel":"styles_componentsMapCarousel__3Yabf","carousel":"styles_carousel__dbvYH","merchantName":"styles_merchantName__6mps2","btn":"styles_btn__1qPC3"};